import { Product } from "@omni/types/api/product/bff/product.model";
import { ProductFieldSet } from "@omni/types/api/product/bff/shared/enums/productFieldSet.enum";
import { ProductBundle } from "@omni/types/api/product/bff/shared/productBundle.model";
import { ProductBundleProduct } from "@omni/types/api/product/bff/shared/productBundleProduct.model";
import { ModelMapper } from "@omni/types/utils/modelMapper";

export type BundleProductModel = {
    quantity: number;
    product: Product<ProductFieldSet.ProductTile>;
};

export type ProductBundleModel = {
    sourceQuantity: number;
    bundleProducts: Array<BundleProductModel>;
};

export const BundleProductMapper: ModelMapper<
    ProductBundleProduct,
    BundleProductModel
> = (model) => {
    return {
        product: model.product,
        quantity: model.quantity ?? 0
    };
};

export const ProductBundleMapper = (
    productBundleApiModel: ProductBundle
): ProductBundleModel => ({
    sourceQuantity: productBundleApiModel.sourceQuantity,
    bundleProducts: productBundleApiModel.products.map(BundleProductMapper)
});
